import { Button, Form, FormInstance, Row, Select } from "antd";
import { useCallback, useMemo } from "react";
import { useSelectFilterSort } from "../../../../lib/hooks/useSelectFilterSort";

type AssignDropdownProps = {
  isClosed: boolean;
  isSaving: boolean;
  form: FormInstance;
  data: any;
};

export const AssignDropdown = ({
  isClosed,
  isSaving,
  form,
  data,
}: AssignDropdownProps) => {
  const { filterSort } = useSelectFilterSort();

  const options: any = useMemo(
    () =>
      data.assignToDropdownList.map((item: any) => ({
        label: item.fullName,
        value: item.id,
        isCurrentUser: item.isCurrentUser,
      })),
    [data],
  );

  const disabled: boolean = useMemo(
    () => isClosed || isSaving,
    [isClosed, isSaving],
  );

  const onAssignToMe = useCallback(() => {
    const me = options.find((item: any) => item.isCurrentUser);

    me && form.setFieldValue("assignedToUserId", me.value);
  }, [options, form]);

  return (
    <Row className="d-block mb-3">
      <Form.Item label="Assignee" name="assignedToUserId" className="mb-1">
        <Select
          optionFilterProp="label"
          options={options}
          showSearch
          filterSort={filterSort}
          disabled={disabled}
          placeholder="Unassigned"
          allowClear
        />
      </Form.Item>
      {!isClosed && (
        <Button
          type="link"
          disabled={disabled}
          className="pa-0"
          size="small"
          onClick={onAssignToMe}
        >
          Assign to me
        </Button>
      )}
    </Row>
  );
};
